import React from "react";
import PropTypes from "prop-types";
import { css } from "@emotion/react";
import { FormattedMessage } from "react-intl";
import Modal from "components/Modal";
import { Col } from "components/Containers";
import { NotificationPreferenceCheckbox } from "components/Notification";

/**
 * RolePublishModal
 *
 * Confirmation modal for publishing a role with an optional
 * notify-subscribers checkbox.
 *
 * @params {Boolean}    show
 * @params {func}       onClose
 * @params {func}       onSubmit
 * @params {Object}     role
 * @params {Boolean}    shouldNotifySubscribers
 * @params {func}       setShouldNotifySubscribers
 * @params {Boolean}    loading
 */
const RolePublishModal = ({
  show = false,
  onClose,
  onSubmit,
  role,
  shouldNotifySubscribers = false,
  setShouldNotifySubscribers,
  loading = false,
}) => (
  <Modal
    show={show}
    onClose={onClose}
    onSubmit={onSubmit}
    title={<FormattedMessage id="Missions.Roles.RoleAdvancedOptions.Publish.Title" />}
    primaryButtonMessageId="Missions.Roles.RoleAdvancedOptions.Publish.Cta"
    secondaryButtonMessageId="Global.Cancel"
    loading={loading}
    showCancel
    showSave
    canSubmit
  >
    <Col gap="1.5rem" css={styles.container}>
      <span css={styles.message}>
        <FormattedMessage
          id="Missions.Roles.RoleAdvancedOptions.Publish.Confirmation1"
          values={{ name: <b>{role?.name}</b> }}
        />
      </span>
      <b css={styles.message}>
        <FormattedMessage id="Missions.Roles.RoleAdvancedOptions.Publish.Confirmation2" />
      </b>
      <div css={styles.checkboxWrapper}>
        <NotificationPreferenceCheckbox
          name="shouldNotifySubscribers"
          value={shouldNotifySubscribers}
          onChange={(_, value) => setShouldNotifySubscribers(value)}
          labelId="Missions.Roles.RoleAdvancedOptions.Publish.NotifyCheckbox"
          descriptionId="Missions.Roles.RoleAdvancedOptions.Publish.NotifyCheckboxDescription"
        />
      </div>
    </Col>
  </Modal>
);

const styles = {
  container: css`
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  `,
  message: css`
    line-height: 1.6;
  `,
  checkboxWrapper: css`
    display: flex;
    justify-content: center;
    width: 100%;
    padding-top: 0.5rem;
  `,
};

RolePublishModal.propTypes = {
  show: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  role: PropTypes.object,
  shouldNotifySubscribers: PropTypes.bool,
  setShouldNotifySubscribers: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

export default RolePublishModal;
